module.exports = __webpack_public_path__ + "static/img/pic-homepage-active1.58e0fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-homepage-active1.png
// module id = 842
// module chunks = 0